import {useDraggable} from '@dnd-kit/core';
import {CSS} from '@dnd-kit/utilities';

export default function Draggable({id, children, data, disabled}){

    const {attributes, listeners, setNodeRef, transform} = useDraggable({
        id: id, 
        data: data,
        disabled: disabled
    });

    const style = {transform: CSS.Translate.toString(transform)};
    
    return <div ref={setNodeRef} style={style} {...listeners} {...attributes}>
        {children}
    </div>
}